<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/b5t5Rn/tc-custom/9780813169934.jpg?1701061060928" alt="This image is the cover for the book Political Companion to James Baldwin, Political Companions to Great American Authors"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Political Companion to James Baldwin, Political Companions to Great American Authors
      </h1>
      <p class="bookDescription body article font2">
        <b>“Uniformly excellent” essays on the work of the renowned author and his “extraordinary relevance in the present moment” (<i>Choice</i>).</b><br/><br/>In seminal works such as <i>Go Tell It on the Mountain</i>, <i>Notes of a Native Son</i>, and <i>The Fire Next Time</i>, acclaimed author and social critic James Baldwin expresses his profound belief that writers have the power to transform society, engage the public, and inspire and channel conversation to achieve lasting change. While Baldwin is best known for his writings on racial consciousness and injustice, he is also one of the country’s most eloquent theorists of democratic life and the national psyche.<br/><br/>In this book, prominent scholars assess the prolific author's relevance to present-day political challenges. Together, they address Baldwin as a democratic theorist, activist, and citizen, examining his writings on the civil rights movement, religion, homosexuality, and women’s rights. They investigate the ways in which his work speaks to and galvanizes a collective American polity, and explore his views on the political implications of individual experience in relation to race and gender.<br/><br/>This volume not only considers Baldwin’s works within their own historical context, but also applies the author’s insights to recent events such as the Obama presidency and the Black Lives Matter movement, emphasizing his faith in the connections between the past and present. These incisive essays will encourage a new reading of Baldwin that celebrates his significant contributions to political and democratic theory.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Susan J. McWilliams
      </h2>
      
      <p class="authorDescription body article">Susan J. McWilliams is assistant professor of politics at Pomona College. She is the author of numerous articles published in journals and edited volumes. She lives in Claremont, California.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University Press of Kentucky
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?02134f57